import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1>4O4</h1>
            <h1>Sorry.... This page not found please try again</h1>
        </div>
    );
};

export default Notfound;